import React from "react";

import {
  ManagementWidgetsItemContainer,
  ManagementWidgetsItemIconContainer,
  ManagementWidgetsItemTitle,
  ManagementWidgetsItemValue,
} from "./styles";

interface ManagementWidgetItemProps {
  title: string;
  value: string | number;
  icon?: JSX.Element;
}
export const ManagementWidgetItem = ({ title, value, icon }: ManagementWidgetItemProps) => {
  return (
    <ManagementWidgetsItemContainer>
      <ManagementWidgetsItemTitle>{title}</ManagementWidgetsItemTitle>
      <ManagementWidgetsItemValue>{value}</ManagementWidgetsItemValue>
      <ManagementWidgetsItemIconContainer>{icon}</ManagementWidgetsItemIconContainer>
    </ManagementWidgetsItemContainer>
  );
};
